import { render, staticRenderFns } from "./ConfirmarPagoModal.vue?vue&type=template&id=33ed4912"
import script from "./ConfirmarPagoModal.vue?vue&type=script&lang=js"
export * from "./ConfirmarPagoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports